import React from 'react'

export const Monthly = () => {
  return (
    <div>Monthly</div>
  )
}
